import { render } from "./DefaultLayout.vue?vue&type=template&id=0c17871c&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=0c17871c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c17871c"],['__file',"src/layouts/DefaultLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c17871c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c17871c', __exports__)) {
    api.reload('0c17871c', __exports__)
  }
  
  module.hot.accept("./DefaultLayout.vue?vue&type=template&id=0c17871c&scoped=true", () => {
    api.rerender('0c17871c', render)
  })

}


export default __exports__